"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlobalSessionTimeoutCallbackService = void 0;
var CommonService_decorator_1 = require("../decorators/CommonService.decorator");
var GlobalSessionTimeoutCallbackService = /** @class */ (function () {
    function GlobalSessionTimeoutCallbackService() {
        this.renewSessionCallbacks = new Set();
        this.sessionTimeoutCallbacks = new Set();
    }
    GlobalSessionTimeoutCallbackService.prototype.subscribeRenewSession = function (callback) {
        var _this = this;
        this.renewSessionCallbacks.add(callback);
        return function () {
            _this.renewSessionCallbacks.delete(callback);
        };
    };
    GlobalSessionTimeoutCallbackService.prototype.subscribeSessionTimeout = function (callback) {
        var _this = this;
        this.sessionTimeoutCallbacks.add(callback);
        return function () {
            _this.sessionTimeoutCallbacks.delete(callback);
        };
    };
    GlobalSessionTimeoutCallbackService.prototype.executeRenewSessionCallback = function () {
        var allFunc = Array.from(this.renewSessionCallbacks).map(function (item) { return item(); });
        return Promise.all(__spreadArray([], __read(allFunc)));
    };
    GlobalSessionTimeoutCallbackService.prototype.executeSessionTimeoutCallback = function () {
        var allFunc = Array.from(this.sessionTimeoutCallbacks).map(function (item) { return item(); });
        return Promise.all(__spreadArray([], __read(allFunc)));
    };
    GlobalSessionTimeoutCallbackService = __decorate([
        CommonService_decorator_1.CommonService('GlobalSessionTimeoutCallbackService'),
        __metadata("design:paramtypes", [])
    ], GlobalSessionTimeoutCallbackService);
    return GlobalSessionTimeoutCallbackService;
}());
exports.GlobalSessionTimeoutCallbackService = GlobalSessionTimeoutCallbackService;
//# sourceMappingURL=GlobalSessionTimeoutCallbackService.js.map